import { DateTime } from 'luxon';

export class AnagraficaStato {
  mygovAnagraficaStatoId: number;
  codStato: string;
  deStato: string;
  deTipoStato: string;
  dtCreazione: DateTime;
  dtUltimaModifica: DateTime;
}